// Bates College's undergraduate majors (#2743). Read on 2026-10-01 from
// the official Bates College 2026-2027 Catalog, The Bates Degree page
// (catalog.bates.edu/academics/bates-degree/): its "Major Fields of Study"
// list ("Departmental and interdisciplinary program majors are offered in the
// following areas"), the asterisks marking interdisciplinary programs dropped,
// plus the Individual Interdisciplinary Major (graduates "with a major in
// Interdisciplinary Studies") and the Engineering Major (the Dual Degree
// Engineering Program) the same page describes. The catalog's department
// menu lists the same 36 majors. Degree is null for every major: Bates
// assigns every student the B.A. at matriculation and any student may elect
// the B.S. (the group note says so). Minors and concentrations are left out.
// The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "bates-college",
    "read": "2026-10-01",
    "intro": "Every major in Bates's official 2026-2027 Catalog. Bates has no separate colleges, so the list is one group of departmental and interdisciplinary majors, plus the two majors the catalog describes on their own. Minors and concentrations are left out.",
    "groups": [
        {
            "name": "Departmental and interdisciplinary majors",
            "source": {
                "label": "Bates College 2026-2027 Catalog, The Bates Degree",
                "url": "https://catalog.bates.edu/academics/bates-degree/"
            },
            "note": "Every Bates student is assigned the Bachelor of Arts on entering, whatever the major; a student may instead complete the Bachelor of Science by adding the catalog's chemistry, calculus and physics courses and declaring it by the end of the first semester of senior year.",
            "majors": [
                {
                    "name": "Africana",
                    "degree": null
                },
                {
                    "name": "American Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Asian Studies",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Chinese",
                    "degree": null
                },
                {
                    "name": "Classical and Medieval Studies",
                    "degree": null
                },
                {
                    "name": "Dance",
                    "degree": null
                },
                {
                    "name": "Digital and Computational Studies",
                    "degree": null
                },
                {
                    "name": "Earth and Climate Sciences",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "European Studies",
                    "degree": null
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": null
                },
                {
                    "name": "Gender and Sexuality Studies",
                    "degree": null
                },
                {
                    "name": "German",
                    "degree": null
                },
                {
                    "name": "Hispanic Studies",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "History and Criticism of Art and Visual Culture",
                    "degree": null
                },
                {
                    "name": "Japanese",
                    "degree": null
                },
                {
                    "name": "Latin American and Latinx Studies",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Politics",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Religious Studies",
                    "degree": null
                },
                {
                    "name": "Rhetoric, Film, and Screen Studies",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Studio Art",
                    "degree": null
                },
                {
                    "name": "Theater",
                    "degree": null
                }
            ]
        },
        {
            "name": "Other majors",
            "source": {
                "label": "Bates College 2026-2027 Catalog, The Bates Degree",
                "url": "https://catalog.bates.edu/academics/bates-degree/"
            },
            "majors": [
                {
                    "name": "Interdisciplinary Studies",
                    "degree": null,
                    "note": "An individual interdisciplinary major you propose, drawing on at least two departments or programs, approved by the Curriculum Review Committee by March 1 of sophomore year."
                },
                {
                    "name": "Engineering",
                    "degree": null,
                    "note": "Through the Dual Degree Engineering Program: three or four years at Bates, then two at an affiliated engineering school. You finish with a Bates undergraduate degree in Engineering and a Bachelor of Science in Engineering from the affiliate."
                }
            ]
        }
    ]
};

export default majors;
